import React, { Fragment, useEffect, useState } from 'react';
import axios from 'axios'
import { useLocation, Navigate } from 'react-router-dom';

import { tokenConfig } from '../utils/apiConfig'
import NavBar from '../components/NavBar'
import LoadingScreen from '../components/LoadingScreen';

function requireAuth(AuthComponent) {
    const Authenticate = props => {
        const location = useLocation()
        const [authenticated, setAuthenticated] = useState(false)
        const [invalidToken, setInvalidToken] = useState(false)
        const [userDetails, setUserDetails] = useState(null)
        const [loading, setLoading] = useState(true)

        useEffect(() => {
            const auth = async () => {
                await axios.get('/api/auth/user', tokenConfig())
                    .then(res => {
                        setAuthenticated(true)
                        setUserDetails(res.data)
                        setLoading(false)
                    })
                    .catch(err => {
                        localStorage.clear()
                        console.log(err)
                        setInvalidToken(true)
                        setUserDetails(null)
                        setLoading(false)
                    });
            }
            auth()
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [authenticated])

        useEffect(() => {
            if (location.state?.requireRefresh) {
                window.history.replaceState(null, document.title, `${location.pathname}${location.search}${location.hash}`)
                window.location.reload()
            }
        }, [location])

        if (loading) return <LoadingScreen />

        if (!authenticated || invalidToken || userDetails?.user?.permissionLevel !== 'Admin') {
            return <Navigate replace to="/" />
        }

        return (
            <Fragment>
                <NavBar authenticated={authenticated} invalidToken={invalidToken} setAuthenticated={setAuthenticated} userDetails={userDetails} />
                <AuthComponent authenticated={authenticated} userDetails={userDetails} {...props} />
            </Fragment>
        )
    }
    return Authenticate
}

export default requireAuth
